import { render } from "./GamesConstraints.vue?vue&type=template&id=cb99736e"
import script from "./GamesConstraints.vue?vue&type=script&lang=js"
export * from "./GamesConstraints.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__